// extracted by mini-css-extract-plugin
module.exports = {"group":"ob_ZHyOF0","featuredPhotos":"ob_Ul5KAh","image":"ob_ZmP73C","card":"ob_ZO2LPo"};